import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

// Inclusive day range, e.g. '6 Sep - 12 Sep'. Adds the year only when the
// range straddles two years, to keep it short in narrow columns.
export function fDateRange(start, end) {
  const from = new Date(start);
  const to = new Date(end);
  if (from.getFullYear() !== to.getFullYear()) {
    return `${format(from, 'd MMM yyyy')} - ${format(to, 'd MMM yyyy')}`;
  }
  return `${format(from, 'd MMM')} - ${format(to, 'd MMM')}`;
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  console.log('this is the date', date);
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}
